<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>WHO DO YOU THINK YOU ARE?</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct" id="p0007-01-0"><a id="pagevii">CONTENTS<br/><br/></a></p><a id="pagevii">
</a><p class="cct" id="p0007-02-1"><a id="pagevii"></a><a href="#/chapter3#toc1" id="con1">1. I Am _________?</a></p>
<p class="cct" id="p0007-P-1"><a href="#/chapter4#toc2" id="con2">2. I Am in Christ</a></p>
<p class="cct" id="p0007-P-2"><span href="#/chapter5#toc3" id="con3" title="Link target outside of Sample">3. I Am a Saint</span></p>
<p class="cct" id="p0007-P-3"><span href="#/chapter6#toc4" id="con4" title="Link target outside of Sample">4. I Am Blessed</span></p>
<p class="cct" id="p0007-P-4"><span href="#/chapter7#toc5" id="con5" title="Link target outside of Sample">5. I Am Appreciated</span></p>
<p class="cct" id="p0007-P-5"><span href="#/chapter8#toc6" id="con6" title="Link target outside of Sample">6. I Am Saved</span></p>
<p class="cct" id="p0007-P-6"><span href="#/chapter9#toc7" id="con7" title="Link target outside of Sample">7. I Am Reconciled</span></p>
<p class="cct" id="p0007-P-7"><span href="#/chapter10#toc8" id="con8" title="Link target outside of Sample">8. I Am Afflicted</span></p>
<p class="cct" id="p0007-P-8"><span href="#/chapter11#toc9" id="con9" title="Link target outside of Sample">9. I Am Heard</span></p>
<p class="cct1" id="p0007-P-9"><span href="#/chapter12#toc10" id="con10" title="Link target outside of Sample">10. I Am Gifted</span></p>
<p class="cct1" id="p0007-P-10"><span href="#/chapter13#toc11" id="con11" title="Link target outside of Sample">11. I Am New</span></p>
<p class="cct1" id="p0007-P-11"><span href="#/chapter14#toc12" id="con12" title="Link target outside of Sample">12. I Am Forgiven</span></p>
<p class="cct1" id="p0007-P-12"><span href="#/chapter15#toc13" id="con13" title="Link target outside of Sample">13. I Am Adopted</span></p>
<p class="cct1" id="p0007-P-13"><span href="#/chapter16#toc14" id="con14" title="Link target outside of Sample">14. I Am Loved</span></p>
<p class="cct1" id="p0007-P-14"><span href="#/chapter17#toc15" id="con15" title="Link target outside of Sample">15. I Am Rewarded</span></p>
<p class="cct1" id="p0007-P-15"><span href="#/chapter18#toc16" id="con16" title="Link target outside of Sample">16. I Am Victorious<br/><br/></span></p>
<p class="cct1" id="p0007-P-16"><span href="#/chapter19#toc17" id="con17" title="Link target outside of Sample"><i>Notes </i></span></p>
<p class="cct1" id="p0007-P-17"><span href="#/chapter20#toc18" id="con18" title="Link target outside of Sample"><i>Acknowledgments </i></span></p>
<p class="cct1" id="p0007-P-18"><span href="#/chapter21#toc19" id="con19" title="Link target outside of Sample"><i>About the Author </i></span></p>
<p class="cct1" id="p0007-P-19"><span href="#/index1#toc20" id="con20" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2abe3cc2